module.exports = __webpack_public_path__ + "media/images/thinking-face-1679f97a8c10ec2238dce6727381966d.svg";